import IssueMessages from './IssueMessages';

export default IssueMessages;
